import { WorkflowEngineClient } from './WorkflowEngineClient'
import { toolboxManager } from '../../ToolboxManager'

export const workflowEngineClient = new WorkflowEngineClient(toolboxManager)
